<template>
  <div id="app">
    <router-view/>
    <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowGlobalRightBox" class="rightBox" @click.self="closeRightBoxFun">
        <component :token="token" :appBool="true" :is="isCompnentElement"></component>
      </div>
    </transition>
    <div v-if="isShow" class="zhezhaoBox"></div>
  </div>
</template>

<script>
import { EventBus } from '@/util/eventBus';
import uiCommonClientguanxitupu from '@/components/common/clientinfo/guanxitupu';
import uiCommonClientheadpath from '@/components/common/clientinfo/headpath';
// 备忘录
import uiHomeMemomodify from '@/components/common/home/memomodify';
// 公告
import uiHomeNoticeinfo from '@/components/common/home/noticeinfo';
// 客户
import uiClientInfo from '@/components/common/clientinfo/index';
// 面试
import uiInterviewInfo from '@/components/common/recruiment/index';
// 合同
import uiContractInfo from '@/components/common/contractinfo/info';
// 登录超时
import uiLock from '@/components/common/home/lock';

export default {
  name: 'App',
  data() {
    return {
      isShow: false,
      // 全局右侧视图框
      token: '',
      isShowGlobalRightBox: false,
      isCompnentElement: 'ui-home-lock',
    };
  },
  components: {
    // 关系图
    'ui-client-info-guanxitupu': uiCommonClientguanxitupu,
    // 头像
    'ui-client-info-headpath': uiCommonClientheadpath,
    // 备忘录
    'ui-home-memomodify': uiHomeMemomodify,
    // 公告
    'ui-home-notice': uiHomeNoticeinfo,
    // 客户
    'ui-home-clientinfo': uiClientInfo,
    // 面试
    'ui-home-interviewinfo': uiInterviewInfo,
    // 合同
    'ui-home-contractinfo': uiContractInfo,
    // 登陆超时
    'ui-home-lock': uiLock,
  },
  created() {
    const that = this;
    EventBus.$on('globalZhezhaoBoxFun', (bool) => {
      that.isShow = bool;
    });
    EventBus.$on('globalRightBoxFun', (ob) => {
      if (!ob.bool && that.isCompnentElement === 'ui-home-lock') {
        that.isShowGlobalRightBox = false;
        that.isCompnentElement = '';
        that.token = '';
      }
      if (that.isCompnentElement === 'ui-home-lock' && that.isShowGlobalRightBox) {
        // 如果已经是锁定状态则不做任何操作
        console.log('不走任何操作');
      }
      if (ob.bool) {
        that.isShowGlobalRightBox = ob.bool;
        that.isCompnentElement = ob.compnent;
        that.token = ob.token;
      }
    });
  },
  methods: {
    closeRightBoxFun() {
      this.isShowGlobalRightBox = false;
      this.token = '';
      this.isCompnentElement = '';
    },
  },
};
</script>

<style scoped lang='less'>
#app {
  height: 100%;
  .zhezhaoBox{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0);
    z-index: 5;
  }
  .rightBox{
    display: flex;
    justify-content: end;
    align-items: start;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 4;
    .closeBox{
      box-shadow: 0 1px 1rem rgba(0, 0, 0, 0.2);
      background: #FFFFFF;
      background: #333333;
      width: 40px;
      height: 100px;
      margin-top: 20px;
      border-bottom-left-radius: 8px;
      border-top-left-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i{
        font-size: 23px;
        color: #666666;
        color: #FFFFFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue